// Helper único de "home por rol". Si un user llega a una ruta no autorizada
// para su rol, lo mandamos a SU home en lugar de mostrar un error UI.
//
// Cubre el caso típico: cambio de user en el mismo browser y queda guardada
// la URL del rol anterior (ej. supervisor con URL /capturar/:lineaId que era
// del líder).

import type { Role } from 'schemas';

export function getHomeForRole(rol: Role): string {
  switch (rol) {
    case 'lider':
      return '/capturar';
    case 'supervisor':
      return '/supervisor';
    case 'coordinador':
      return '/coordinador';
    case 'directivo':
      return '/directivo';
    case 'admin_tenant':
      return '/admin';
    case 'super_admin':
      return '/super-admin';
    case 'pantalla':
      return '/pantalla';
    default:
      return '/';
  }
}
